module.exports = __webpack_public_path__ + "media/images/games/clash-royale/card-rare-1f52c5fa378a97f135ab3059c15865f9.png";